import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { OrderPipe } from 'ngx-order-pipe';
@Component({
  selector: 'app-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss'],
      providers: [OrderPipe] // Add this line
})
export class PageTitleComponent implements OnInit {
  @Input() title: string;
  @Input() sideTitle: boolean;
  @Output() list: EventEmitter<null> = new EventEmitter();
  @Output() addNew: EventEmitter<null> = new EventEmitter();
  constructor() { }
  ngOnInit() {
  }
}
